module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./packages/lui-modalnotification/theme/lui-modalnotification.global.scss
// module id = 279
// module chunks = 0 1 30